import React, { useState } from "react";
import { GetList } from "../../../hook/getList.tsx";
import {
  Button,
  Checkbox,
  Modal,
  Popconfirm,
  Spin,
  Table,
  type TableColumnsType,
  type TableProps,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { request } from "../../../api/request.tsx";
import UpdateBanner from "../update-banner/index.tsx";
import PopupsItems from "./popupsItems.tsx";
import UpdatePopups from "../update-popups/index.tsx";

interface PageChangeEvent {
  selected: number;
}

const ListPopups = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [infoUpdate, setInfoUpdate] = useState<any>(undefined);
  const [isReload, setIsReload] = useState(false);

  const { data, loading } = GetList<any>({
    url: `banner/get-home-popupbanner`,
    dependencies1: isReload,
  });

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const renderUser = (item: any, index: number) => {
    return (
      <div className="flex justify-center">
        <PopupsItems item={item} key={index} index={index} />
      </div>
    );
  };

  // new
  const columns: TableColumnsType<any> = [
    {
      title: "Hình ảnh",
      dataIndex: "url",
      render: (text: string) => (
        <div>
          <img src={text} className="lg:w-32 w-28 object-contain"></img>
        </div>
      ),
    },
    // {
    //   title: "Tên",
    //   dataIndex: "name",
    // },
    {
      title: "Hành động",
      render: (_: any, record: any) => (
        <div className="flex gap-2">
          <button
            onClick={() => {
              showModal();
              setInfoUpdate(record);
            }}
            className="px-3 py-1 bg-blue-400 text-white rounded"
          >
            Sửa
          </button>
          <Popconfirm
            title="Xoá popups"
            description="Bạn có chắc muốn xoá popups này không?"
            okText="Xác nhận"
            cancelText="Không"
            onConfirm={async () => {
              console.log("ok === ");
              const response = await request(
                "/banner/delete-home-popupbanner",
                {
                  id: record?.id,
                },
                "POST"
              );
              console.log("response ==== ", response);
              if (response?.status) {
                setIsReload(!isReload);
              }
            }}
          >
            <button className="px-3 py-1 bg-red-500 text-white rounded">
              Xoá
            </button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    // <div className="grid gap-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5">
    //   {data?.length > 0 && data?.map(renderUser)}
    // </div>
    <>
      <Modal
        closable={{ "aria-label": "Custom Close Button" }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <div className="h-fit">
          <UpdatePopups
            handleCancel={handleCancel}
            setIsReload={setIsReload}
            isReload={isReload}
            infoUpdate={infoUpdate}
          ></UpdatePopups>
        </div>
      </Modal>
      <div className="flex flex-col gap-4">
        <div className="text-2xl text-center text-[pink] font-bold">
          DANH SÁCH VÀ CẬP NHẬT POPUPS
        </div>
        {loading ? (
          <Spin indicator={<LoadingOutlined spin />} size="large" />
        ) : (
          <Table<any>
            // rowSelection={{ type: selectionType, ...rowSelection }}
            columns={columns}
            dataSource={data}
          />
        )}
      </div>
    </>
  );
};

export default ListPopups;
